import api from '@/utils/api';
import {
    FETCH_DOCTOR_CUSTOMERS
} from './types';
import { NotificationManager } from 'react-notifications';

export const fetchCustomers = (filter) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.get('/doctor-customers', { params: filter}).then(res => {
            dispatch({
                type: FETCH_DOCTOR_CUSTOMERS,
                payload: res.data.data
            });
            resolve(res.data);
        }).catch(err => {
            console.log(err)
            NotificationManager.error(err.response?.data?.msg);
            reject(err);
        })
    })
}
